import { FC } from 'react';
import { Stack } from '../../shared/layouts';
import OverviewCard from '../../shared/OverviewCard';
import {
  getRequestItemKey,
  RequestItem,
  transformOverviewCardProps
} from './requestTypes';

const RequestList: FC<{ data: RequestItem[] }> = ({ data }) => {
  return (
    <Stack space="m">
      {data.map(verzoek => (
        <OverviewCard
          fromRequestsPage
          key={getRequestItemKey(verzoek)}
          {...transformOverviewCardProps(verzoek)}
        />
      ))}
    </Stack>
  );
};

export default RequestList;
